import { put, takeLeading } from "@redux-saga/core/effects"
import { Effect } from "@redux-saga/types"
import { call } from "redux-saga-test-plan/matchers"
import API from "../../../../apis/contextmeeting/api"
import { withAuthHeader } from "../../../../apis/contextmeeting/withAuthHeader"
import { displayUserMessageAction } from "../../../userMessage/state/userMessageActions"
import { UserMessageTypes } from "../../../userMessage/state/userMessageTypes"
import { AdminActionTypes, IUploadTermsFileFormValues } from "../adminTypes"

const valuesToFormData = (values: IUploadTermsFileFormValues) => {
  const data = new FormData()
  data.append("terms[file]", values.file)
  return data
}

export function* uploadTermsFileAsync(action: Effect): Generator {
  try {
    const data = valuesToFormData(action.payload.values)
    const config = withAuthHeader()
    // the upload can't be done with JSON, it needs this content type.
    config.headers["Content-Type"] = "multipart/form-data"

    yield put(displayUserMessageAction({
      messageKey: "fileUploadStarted",
      type: UserMessageTypes.MESSAGE
    }))

    const response: any = yield call(API.post, "/terms", data, config)

    yield put({
      type: AdminActionTypes.UPLOAD_TERMS_FILE_ASYNC_SUCCESS,
      payload: response.data
    })

    yield put(displayUserMessageAction({
      messageKey: "fileUploadSuccess",
      type: UserMessageTypes.SUCCESS
    }))
  } catch (error) {
    yield put({
      type: AdminActionTypes.UPLOAD_TERMS_FILE_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "fileUploadError",
      type: UserMessageTypes.ERROR
    }))
  }
}

export function* watchUploadTermsFileAsync(): Generator {
  yield takeLeading(AdminActionTypes.UPLOAD_TERMS_FILE_ASYNC_PENDING, uploadTermsFileAsync)
}
